import { useLogger } from '@omnia/ui/src/lib/hooks/useLogger'
import { observer } from 'mobx-react-lite'
import type { FC } from 'react'
import { useEffect } from 'react'
import { useAsync } from 'react-async'
import { useSubscriptionNotifications } from '@/common/hooks/useSubscriptionNotifications'
import { hasMemberSpendingPoints } from '@/common/utils/memberDetails/hasMemberSpendingPoints'
import { MemberPointsBalanceContainerConfigurationPropsApi } from '@/content/components/memberPointsBalanceContainerConfiguration/models'
import { cmsService } from '@/content/services/cms.service'
import { PageResponse } from '@/content/services/models'
import { navigationService } from '@/content/services/navigation.service'
import { useAvailableRewards } from '@/features/members-area/reward-store/hooks/useAvailableRewards'

class MemberPointsBalanceConfigurationResponse extends PageResponse {
    public components = {
        MemberPointsBalanceContainerConfiguration: new MemberPointsBalanceContainerConfigurationPropsApi(),
    }
}

export const NotificationsCount: FC = observer(() => {
    const logger = useLogger('NotificationCount')

    const { numberOfRewards, hasRewards } = useAvailableRewards({ hideRewardTypes: [] }, logger)
    const { notificationsCount, hasNotifications } = useSubscriptionNotifications()
    const { data: balanceConfiguration, error } = useAsync<MemberPointsBalanceConfigurationResponse>(
        cmsService.loadPageComponents,
        {
            data: new MemberPointsBalanceConfigurationResponse(),
            friendlyUrl: navigationService.getPageUrl('AccountHome', undefined, false, 'AccountHome'),
        }
    )

    useEffect(() => {
        if (error) logger.error('Failed to load member points balance notification configuration', error)
    }, [error, logger])

    const displayPointBalanceContainer =
        balanceConfiguration?.components.MemberPointsBalanceContainerConfiguration.displayPointBalanceContainer
    const hasSpendingPoints = hasMemberSpendingPoints()

    if (!hasRewards && !hasNotifications && !hasSpendingPoints) {
        return
    }

    const count = numberOfRewards + notificationsCount + (hasSpendingPoints && displayPointBalanceContainer ? 1 : 0)
    return <div className="notifications-count">{count}</div>
})
